/**
 @ngdoc service
 @name mapLeadTileService
 @description
 factory used by mapTilesJsonData.js to construct tile data into tileData object
 */

(function() {
    'use strict';

    var mapLeadTileService = function(tileDataFactory) {

        var map = function(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData){
            var self = this;

            // Assigning tile factory function with parameters to variable
            var tileFactory = new tileDataFactory.constructTileData(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData);

            // Adding labels to column structured data
            //Row1
            tileFactory.addFieldToColumn1(tileFactory.field.newField('id'));
            tileFactory.addFieldToColumn2(tileFactory.field.newInactiveWarningField('managerEmail', ['invalidEmailWarning', 'spamEmailWarning'], 'unsubscribedFromEmails', 'unsubscribedFromEmails', 'actionLogURI'));
            tileFactory.addFieldToColumn3(tileFactory.field.newField('businessName'));
            tileFactory.addFieldToColumn4(tileFactory.field.newField('dateCreated', 'dateTime'));

            //Row2
            tileFactory.addFieldToColumn1(tileFactory.field.newField('leadSource'));
            tileFactory.addFieldToColumn2(
                            tileFactory.field.newRankedInactiveField(
                                'managerPhone',
                                [['ctpsBarring', 'ctpsBarring'], ['unsubscribedFromCalls', 'unsubscribedFromCalls']],
                                'actionLogURI'
                            )
                        );
            tileFactory.addFieldToColumn3(tileFactory.field.newAddressField('town'));
            tileFactory.addFieldToColumn4(tileFactory.field.newField('lastUpdated', 'dateTime'));

            //Row3
             tileFactory.addFieldToColumn1(tileFactory.field.newField('createdBy'));
            (function() {
              var assigneeField = tileFactory.field.newField('assignee');
              var assigneeRaw = rawTileData.assignee;
              if (assigneeField) {
                if (Array.isArray(assigneeRaw)) {
                 if (assigneeRaw.length > 1) {
                  // Multiple assignees: show first + "(Multiple)" and tooltip with all
                    assigneeField.value = assigneeRaw[0] + ' (Multiple)';
                    assigneeField.additionalInfo = assigneeRaw.join(', ');
                 } else if (assigneeRaw.length === 1) {
                  // Single assignee: show only name, not ["name"]
                    assigneeField.value = assigneeRaw[0];
                    assigneeField.additionalInfo = null;
                 } else {
                   // No assignee: show blank, not []
                    assigneeField.value = '';
                    assigneeField.additionalInfo = null;
                 }
                } else if (assigneeRaw == null) {
                // Null/undefined assignee
                  assigneeField.value = '';
                  assigneeField.additionalInfo = null;
                } else {
                // Fallback if backend sends a plain string
                  assigneeField.value = assigneeRaw;
                  assigneeField.additionalInfo = null;
                }
              }
              tileFactory.addFieldToColumn2(assigneeField);
            })();

          tileFactory.addFieldToColumn4(tileFactory.field.newField('actionDate', 'dateTime'));

            //Message field : Collapsible
           tileFactory.addTextField(tileFactory.textField.newTextField('message'));

            tileFactory.addStatus(tileFactory.status.newStatusWithInfoAndStyling('leadStatus', null, [tileFactory.LOOKUP_VALUE.LEAD_SUCCESS,tileFactory.LOOKUP_VALUE.LEAD_CLOSED],
                [tileFactory.LOOKUP_VALUE.LEAD_UNASSIGNED],
                [tileFactory.LOOKUP_VALUE.LEAD_ASSIGNED]));

          if(rawTileData.managerActivityStatus.id !== null) {
            tileFactory.addStatus(tileFactory.status.newStatusWithInfoAndStylingAndPrefix('managerActivityStatus', 'statusHelpText', 'Manager Activity: ',
              [tileFactory.LOOKUP_VALUE.MANAGER_STATUS_BOOKING, tileFactory.LOOKUP_VALUE.MANAGER_STATUS_PROSPECTIVE],
              [tileFactory.LOOKUP_VALUE.MANAGER_STATUS_LEFT],
              [tileFactory.LOOKUP_VALUE.MANAGER_STATUS_JOB]));
          }

            return tileFactory.tileData;

        };

        return {
            map : map
        };
    };

    mapLeadTileService.$inject = ['tileDataFactory'];
    angular.module('app').factory('mapLeadTileService', mapLeadTileService);
}());
